module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/store_images/2_4bf217a5c63a78c051cd7e7516df2a34.png";